import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=fbfb8e62&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./Add.vue?vue&type=style&index=0&id=fbfb8e62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfb8e62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/nantong-hrpark-prod-mobile-property(微信公众号-物业）/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fbfb8e62', component.options)
    } else {
      api.reload('fbfb8e62', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=fbfb8e62&scoped=true&", function () {
      api.rerender('fbfb8e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/property/repair/Add.vue"
export default component.exports